<template>
  <div class="wrapper">
    <div class="login">
      <div class="login__wrap">
        <div class="login__logo">
          <a href=""
            ><img
              src="~ThemePath/images/logo/loto_color.png"
              alt="loto hotpicks"
          /></a>
          <a href=""
          ><img
              src="~ThemePath/images/logo/loto_plus_color.png"
              alt="loto hotpicks"
          /></a>
          <a href=""
            ><img
              src="~ThemePath/images/logo/loto_vert_color.png"
              alt="loto vert hotpicks"
          /></a>
        </div>
        <div class="login__title">
          <h2>{{ getTranslatedText("merchant application") }}</h2>
        </div>
        <div class="login__content">
          <div v-if="step === 1" class="login__form">
            <FormCommon
              :formItem="formItem"
              :dataForm="dataForm"
              nameFunction="on-change-value"
            />
            <div class="login__form--button">
              <ButtonCommon
                :isNoHover="true"
                :isLoading="isLoadingButton"
                text="Connect"
                @action-button="handleLogin()"
                type="login"
              />
            </div>
          </div>
          <div v-if="step === 2" class="login__terminal">
            <div class="login__terminal__label">
              {{ getTranslatedText("Serial Number") }}
            </div>
            <div class="login__terminal__number">{{ renderSerialNumber() }}</div>
            <div class="login__form--button">
              <ButtonCommon
                :isNoHover="false"
                text="Back"
                @action-button="handleBack()"
                type="login"
              />
            </div>
          </div>
          <div class="login__tag">
            <span>{{ handleTextAppVersion() }}</span>
            <span @click="step = 2">{{
              getTranslatedText("terminal id")
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import languageMixins from "@/mixins/language/language-mixins";
import FormCommon from "@/components/common/form";
import ButtonCommon from "@/components/common/button";
import EventBus from "@/utils/EventBus";
import AuthService from "@/services/auth.service";
import GamesService from "@/services/games.service";
import { setToken, setUserInfo } from "@/services/axios";
import {setConfig, isStrEmpty, getSettingDevice} from '@/utils/utils';
const TIME_ZONE = process.env.VUE_APP_TIME_ZONE;
export default {
  mixins: [languageMixins],
  components: { FormCommon, ButtonCommon },
  data() {
    return {
      step: 1,
      formItem: [
        {
          label: "Merchant User ID",
          name: "teller_id",
          type: "number",
          required: true,
          inputmode:'numeric',
          pattern:'[0-9]*',
          maxlength:12
        },
        {
          label: "PIN",
          name: "teller_pin",
          required: true,
          type: "otp",
          otp_type: "password",
          otp_length: 4,
        },
      ],
      dataForm: {
        teller_id: "",
        teller_pin: "",
      },
      isLoadingButton:false
    };
  },
  created() {
    EventBus.$on("on-change-value", (value) => {
      this.changeValueLogin(value);
    });
  },
  destroy() {
    EventBus.$off("on-change-value");
  },
  methods: {
    validateForm(dataForm) {
      if (!dataForm.teller_id) {
        return {
          field: "teller_id",
          message: "Merchant User ID is required",
        };
      } else {
        if (!dataForm.teller_pin) {
          return {
            field: "teller_pin",
            message: "PIN is required",
          };
        } else if (dataForm.teller_pin.length < 4) {
          return {
            field: "teller_pin",
            message: "PIN must be exactly 4 characters",
          };
        }
      }
      return null;
    },
    async handleLogin() {
      const validationErrors = this.validateForm(this.dataForm);
      const param = {
          title: '',
          status: "error",
          description: "Please Try Again",
        };
      if (validationErrors) {
        param.title = validationErrors.message
        EventBus.$emit("on-show-notications", param);
        return;
      }
      try {
        this.isLoadingButton = true;
        const param = {
          teller_id: this.dataForm.teller_id,
          teller_pin: this.dataForm.teller_pin,
          ignore_cache: true
        };
        const res = await AuthService.login(param);
        if (res.status === "success") {
          if(!res.data.details.last_logged){
            res.data.details.last_logged = this.$helpers.changeTimeZone(new Date(),TIME_ZONE);
          }
          setToken(res.data.token);
          setUserInfo(res.data.details);
          if (!isStrEmpty(res.data.config)) {
            await GamesService.getListGame();
            setConfig(res.data.config);
            await this.$store.dispatch('handleConfig', res.data.config);
          }
          await this.$store.dispatch('handleUserInfo', res.data.details);
          this.$router.push("/");
        } else {
          param.title = res.data?.errors
          ? res.data.errors.map(item => item.message).join(', ')
          : res.message;
          EventBus.$emit("on-show-notications", param);
        }
        this.isLoadingButton = false;
      } catch (error) {
        param.title = error.data?.errors
          ? error.data.errors.map(item => item.message).join(', ')
          : error.message;
        EventBus.$emit("on-show-notications", param);
        this.isLoadingButton = false;
      }
    },

    renderSerialNumber() {
      let settings = !isStrEmpty(getSettingDevice()) ? JSON.parse(getSettingDevice()) : ''
      let uniqueId = settings?.uniqueId || ''
      let serial = !isStrEmpty(settings) ? settings.serial.replace('unknown', uniqueId) : '_________'
      return serial
    },
    handleBack() {
      this.step = 1;
    },
    handleTextAppVersion() {
      return this.$t(`version ${this.$store.state.versionApp}`);
    },
    changeValueLogin(item) {
      let { event, name } = item;
      if (event instanceof Event) {
        this.dataForm[name] = event.target.value;
      } else {
        this.dataForm[name] = event;
      }
    },
  },
};
</script>
<style lang="scss">
@import "~ThemePath/scss/login/_index.scss";
</style>
